// extracted by mini-css-extract-plugin
var _1 = "XaluXekk";
var _2 = "LEo6dc9a";
export { _1 as "inputCard", _2 as "mobileInput" }
